module.exports = __webpack_public_path__ + "img/airtight-hatch.3be51ed5.svg";